import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import styles from "./SuccessPlan.module.scss";
import CustomerRevenueProfile from "components/summary/index/ExpandPlanRevamp/CustomerRevenueProfile";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import { useEffect, useState } from "react";
import { BemsType } from "components/summary/index/ExpandPlanRevamp";

type RevenueProfileDialogProps = {
  open: boolean;
  onClose: () => void;
  spState: SuccessPlanState;
};

const RevenueProfileDialog = ({ open, onClose, spState }: RevenueProfileDialogProps) => {
  const { spData, selectedAccounts } = spState;
  const [active, setActive] = useState("sub");

  const [bems, setBems] = useState<BemsType>({
    escalations: 0,
    wellPlanExists: false,
    capExists: false,
    caseTotal: 0,
    caseActive: 0,
    caseClosed: 0,
  });

  useEffect(() => {
    if (spData) {
      const bemsAggr = spData?.accounts?.reduce(
        (acc: BemsType, curr: any) => {
          return {
            escalations: acc.escalations + curr?.attributes?.escalations,
            wellPlanExists: acc.wellPlanExists || !!curr?.attributes?.wellPlanExists,
            capExists: acc.capExists || !!curr?.attributes?.capExists,
            caseTotal: acc.caseTotal + curr?.attributes?.caseTotal,
            caseActive: acc.caseActive + curr?.attributes?.caseActive,
            caseClosed: acc.caseClosed + curr?.attributes?.caseClosed,
          };
        },
        {
          escalations: 0,
          wellPlanExists: false,
          capExists: false,
          caseTotal: 0,
          caseActive: 0,
          caseClosed: 0,
        }
      );
      setBems(bemsAggr);
    }
  }, [spData]);

  return (
    <Dialog
      open={open}
      maxWidth="xl"
      fullWidth
      onClose={onClose}
    >
      <DialogTitle>
        <div className={styles["title-box"]}>
          <span className={styles["title-box__title"]}>Revenue Profile</span>
          <IconButton
            size="small"
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <CustomerRevenueProfile
          data={spData}
          selectedData={selectedAccounts}
          active={active}
          setActive={setActive}
        />
        <Typography
          style={{
            marginLeft: "40px",
            marginTop: "16px",
            fontSize: "16px",
            fontWeight: "600",
          }}
        >
          TAC, BEMs and Escalation Engineering Case Information (Last 90 Days)
        </Typography>
        <TableContainer
          style={{
            margin: "16px 16px 16px 40px",
            width: "auto",
          }}
        >
          <Table>
            <TableHead>
              <TableRow>
                <TableCell
                  align="center"
                  style={{
                    color: (bems?.escalations ?? 0) > 0 ? "#EE6245" : "",
                  }}
                >
                  Open Escalation Engineering last 90 days
                </TableCell>
                <TableCell align="center">Get Well Plan</TableCell>
                <TableCell align="center">CAP Plan</TableCell>
                <TableCell align="center">Total Cases</TableCell>
                <TableCell align="center">Active Cases</TableCell>
                <TableCell align="center">Closed Cases</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                  style={{
                    color: (bems?.escalations ?? 0) > 0 ? "#EE6245" : "",
                  }}
                >
                  {bems.escalations ?? "..."}
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                >
                  {!!bems.wellPlanExists ? "Yes" : "No"}
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                >
                  {!!bems.capExists ? "Yes" : "No"}
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                >
                  {bems.caseTotal ?? "..."}
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                >
                  {bems.caseActive ?? "..."}
                </TableCell>
                <TableCell
                  align="center"
                  component="th"
                  scope="row"
                >
                  {bems.caseClosed ?? "..."}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default RevenueProfileDialog;
